import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  role: "list",
  class: "mt-2 space-y-2 text-sm"
}
const _hoisted_2 = {
  key: 0,
  class: "text-gray-600"
}
const _hoisted_3 = { class: "uppercase text-gray-400 pr-2 text-xs" }




export default /*#__PURE__*/_defineComponent({
  __name: 'confItemDescriptionPartsSub',
  props: ["subList"],
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_conf_item_description_parts_sub = _resolveComponent("conf-item-description-parts-sub", true)!

  return (__props.subList != 'undefined')
    ? (_openBlock(), _createElementBlock("ul", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.subList, (subDetail, subDetailIdx) => {
          return (_openBlock(), _createElementBlock("li", {
            class: "text-gray-400",
            key: subDetailIdx
          }, [
            (subDetail.title !== '')
              ? (_openBlock(), _createElementBlock("p", _hoisted_2, [
                  _createElementVNode("span", _hoisted_3, _toDisplayString(subDetail.title) + ":", 1),
                  _createTextVNode(" " + _toDisplayString(subDetail.value), 1)
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_conf_item_description_parts_sub, {
              "sub-list": subDetail.sub
            }, null, 8, ["sub-list"])
          ]))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}
}

})